import React from 'react';
import { PageContent } from '@core/ui';
import { TableProvider } from '@core/table';

import { BranchInspectionsTableContext } from '../contexts';
import { useBranchInspectionsTableContext } from '../hooks';
import { BranchInspectionsTable, BranchInspectionsActionBar } from '../containers';

export const BranchInspectionsPage = () => {
  const { onFetch } = useBranchInspectionsTableContext();

  return (
    <TableProvider name='branch-inspections' context={BranchInspectionsTableContext} onFetch={onFetch}>
      <PageContent $contain={true}>
        <BranchInspectionsActionBar />
        <BranchInspectionsTable />
      </PageContent>
    </TableProvider>
  );
};
